import styled from 'styled-components';

import { PODCAST_COLORS } from 'client/utils';

export const IntegrationRedirectScreenSection = styled.section`
  /* The 369px is the height of the nav (96px) + height of the footer (98px) + margin of the footer (175px) */
  height: calc(100vh - 369px);
  min-height: 480px;
  padding-top: 5%;
  background: ${PODCAST_COLORS.WHITE.color};

  @media (max-width: 880px) {
    /* The 377px is the height of the nav (76px) + height of the footer (275px) + margin of the footer (26px) */
    height: calc(100vh - 377px);
  }
`;
